import React, { useState, useEffect} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, getYear, getMonth } from 'date-fns';

// Función para generar un array de años dentro de un rango
const range = (start, end, step = 1) => {
  let output = [];
  for (let i = start; i <= end; i += step) {
    output.push(i);
  }
  return output;
};

/*
Si label no está definido, con la funcion convertSnakeCaseToText convierto el atributo name en label
*/
const TextControl = ({ value, name, handleInput, label, type='text', hasLabel=true, margin='mb-3', disabled=false }) => {
  const [caption, setCaption] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const years = range(1944, getYear(new Date()) + 1, 1);
  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agost",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const handleBirthday = (date) => {
    setStartDate(date)
    handleInput({target: {name: name, type: type, value: format(date, 'yyyy-MM-dd')}})
  }

  useEffect(() => {
    if (label===undefined){
      if (name.includes('.')) {
        const [parentKey, childKey] = name.split('.');
        setCaption( convertSnakeCaseToText(childKey));
      } else {
        setCaption( convertSnakeCaseToText(name));
      }
    } else {
      setCaption(label)
    }
  }, [name]);

  const convertSnakeCaseToText = (snakeCaseString) => {
    const words = snakeCaseString.split('_');
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    return capitalizedWords.join(' ');
  }

  return (
    <>
      <div className={(type !== 'hidden' && hasLabel && type !== 'label') ? `form-floating ${margin}` : '' }>
        {
          type === 'birthday' ? (
            <>
              { hasLabel && (<span className='me-1' htmlFor={name}>{caption}</span>) }
              <DatePicker
                renderCustomHeader={({
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled,
                }) => (
                  <div
                    style={{
                      margin: 10,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                      {"<"}
                    </button>
                    <select
                      value={getYear(date)}
                      onChange={({ target: { value } }) => changeYear(value)}
                    >
                      {years.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    <select
                      value={months[getMonth(date)]}
                      onChange={({ target: { value } }) =>
                        changeMonth(months.indexOf(value))
                      }
                    >
                      {months.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                      {">"}
                    </button>
                  </div>
                )}
                selected={startDate}
                // onChange={(date) => setStartDate(date)}
                // onChange={(e) => handleInput(e)}
                onChange={(date) => handleBirthday(date)}
                className="form-control"
                dateFormat="dd-MM-yyyy"
                placeholderText={caption}
                name={name}
              />

              {/* <pre>{JSON.stringify(startDate, null, 2)}</pre> */}

            </>
          ) : (
            <>
              {
                type === 'label' ? (
                  <>
                  <label className='fw-bold' htmlFor={name}>{caption}:</label>
                  <span className='ms-1'>{value}</span>
                  </>
                  
                ) : (
                  <>
                  <input
                    type={type}
                    step={type==='number' ? '0.001' : '0'}
                    name={name}
                    disabled={disabled}
                    value={value || ''}
                    className="form-control"
                    onChange={(e) => handleInput(e)}
                    placeholder={caption}
                    id={name} />
                    { type !== 'hidden' && hasLabel && (<label htmlFor={name}>{caption}</label>) }                  
                  </>
                )
              }            
            </>
          )
        }
      </div>
    </>
  );
};

export default TextControl;